import { apiUrl } from './config';
export const getExam = ['get', `${apiUrl}/exams/id`];



// WEBPACK FOOTER //
// ./src/common/apis.js